import React, { useRef } from 'react';
import styles from './HeaderContent.scss';
import type { HeaderIconType } from 'mini-header';
import { HeaderIcons } from 'mini-header';
import { isMeControlEnabled } from 'mini-mecontrol/lib/utils/meControlCommonUtils';
import { isMultiAccountPopupEnabled } from 'multi-account/lib/utils/isMultiAccountPopupEnabled';
import { MeControlWrapper } from 'mini-mecontrol/lib/components/MeControlWrapper';
import { MultiAccountPopupWrapper } from './MultiAccountPopupWrapper';

export interface RightHeaderContentProps {
    rightIcons: HeaderIconType[];
    navigationButtonRef?: React.RefObject<HTMLDivElement>;
    ariaLabel?: string;
}

/**
 * Component for rendering the right header content.
 */
export const RightHeaderContent = (props: RightHeaderContentProps) => {
    const { rightIcons } = props;

    const personaRef = useRef<HTMLDivElement>(null);

    const rightIconsWithPersonaIcon = [
        ...rightIcons,
        isMultiAccountPopupEnabled() && {
            icon: <MultiAccountPopupWrapper personaRef={personaRef} />,
        },
    ];

    return (
        <div className={styles.rightHeaderContainer}>
            <HeaderIcons icons={rightIconsWithPersonaIcon} rightAligned />
            {isMeControlEnabled() && <MeControlWrapper />}
        </div>
    );
};
